export default __webpack_public_path__ + "static/media/masterclassImage.80841256.png";